module.exports = __webpack_public_path__ + "static/media/eye-icon-striked.67986b0f.svg";